import ErrorMessage from "components/ErrorMessage";
import React, { useContext, useRef, useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import FormData from "form-data";
import { apiGet } from "../../utils/apiFetch";
import apiPath from "../../utils/apiPath";
import AuthContext from "context/AuthContext";
import OButton from "components/reusable/OButton";
import { AiFillCamera } from "react-icons/ai";
import OImage from "components/reusable/OImage";
import { useTranslation } from "react-i18next";
import { preventMaxInput } from "utils/validations";
import formValidation from "../../utils/formValidation";
import OInputField from "components/reusable/OInputField";
import AvatarEditor from "react-avatar-editor";
import { Slider } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import helpers from "../../utils/helpers";

const Profile = () => {
  const { t } = useTranslation();
  const {
    register,
    handleSubmit,
    reset,
    watch,
    formState: { errors, isDirty, dirtyFields },
  } = useForm({ mode: "onChange", shouldFocusError: true, defaultValues: {} });
  const [profilePicError] = useState("");
  const [open, setOpen] = useState(false);
  const [updateProfileLoading, setUpdateProfileLoading] = useState(false);
  const { updateProfile, user, updatePageName } = useContext(AuthContext);
  const profilePicRef = useRef();
  const [recordsTemp, setRecordTemp] = useState("");
  const [listTemp, setListTemp] = useState("");
  const [cat, setCat] = useState(user?.countryID);
  const [subCat, setSubCat] = useState(user?.cityID);
  const [state, setState] = useState(user?.stateID);
  const [isCatError, setIsCatError] = useState(false);
  const [isSubCatError, setIsSubCatError] = useState(false);
  const [isStateError, setIsStateError] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState(user?.countryID);
  const [stateList, setStateList] = useState([]);

  useEffect(() => {
    reset({
      name: user.name,
      email: user.email,
      mobile: user.mobile,
      profilePic: user.profilePic,
      profilePicture: user.profilePicture,
      countryID: user?.countryID,
      stateID: user?.stateID,
      city: user?.city,
      address: user?.address,
      countryCode: user?.countryCode,
    });
    setSelectedCountry(user?.countryID);
  }, [user]);

  var editor = "";
  const [picture, setPicture] = useState({
    cropperOpen: false,
    img: null,
    zoom: 2,
    croppedImg: user?.profilePic || user?.profilePicture,
  });

  const handleSlider = (event, value) => {
    setPicture({
      ...picture,
      zoom: value,
    });
  };

  const handleCancel = () => {
    setPicture({
      ...picture,
      cropperOpen: false,
    });
    setOpen(false);
  };

  const setEditorRef = (ed) => {
    editor = ed;
  };

  const handleSave = (e) => {
    if (setEditorRef) {
      const canvasScaled = editor.getImageScaledToCanvas();
      const croppedImg = canvasScaled.toDataURL();
      setPicture({
        ...picture,
        img: null,
        cropperOpen: false,
        croppedImg: croppedImg,
      });
    }
    setOpen(false);
  };

  const handleFileChange = (e) => {
    let url = URL.createObjectURL(e.target.files[0]);
    console.log(url);
    setPicture({
      ...picture,
      img: url,
      cropperOpen: true,
      imageName: e.target.files[0].name,
    });
    setOpen(true);
  };

  const checkFields = () => {
    let isValid = true;
    if (!cat) {
      setIsCatError(true);
      isValid = false;
    }
    if (!cat) {
      setIsCatError(true);
      isValid = false;
    } else {
      setIsCatError(false);
    }
    if (!state) {
      setIsStateError(true);
      isValid = false;
    } else {
      setIsStateError(false);
    }
    return isValid;
  };

  const handleSubmitForm = async (data) => {
    try {
      setUpdateProfileLoading(true);
      const formData = new FormData();
      if (user.role === "admin" || user.role === "subadmin") {
        switch (true) {
          case dirtyFields.name:
            formData.append("name", data.name);
            break;

          case dirtyFields.email:
            formData.append("email", data.email);
            break;

          default:
            break;
        }
        await helpers.cropPicture(picture, "profilePic", formData);
      }
      const formDataHR = new FormData();
      const countryCodesHR = recordsTemp.find(
        (items) => items?._id === selectedCountry,
      );
      if (user.role === "HRAdmin") {
        const isValid = checkFields();
        if (!isValid) return;
        if (dirtyFields.email) {
          formDataHR.append("email", data.email);
        }

        helpers.isParameterMakeObject("address", formDataHR, data.address);
        helpers.isParameterMakeObject("name", formDataHR, data.name);
        helpers.isParameterMakeObject(
          "countryCode",
          formDataHR,
          countryCodesHR.countryCode,
        );
        helpers.isParameterMakeObject("mobile", formDataHR, data.mobile);
        helpers.isParameterMakeObject("city", formDataHR, data.city);
        helpers.ifParameter(cat, formDataHR, "countryID", cat);
        helpers.ifParameter(state, formDataHR, "stateID", state);
        await helpers.cropPicture(picture, "profilePicture", formDataHR);
      }
      const formDataAccountant = new FormData();
      const countryCodes = recordsTemp.find(
        (items) => items?._id === selectedCountry,
      );
      if (user.role === "AccountantAdmin") {
        const isValid = checkFields();
        if (!isValid) return;
        if (dirtyFields.email) {
          formDataAccountant.append("email", data.email);
        }

        helpers.isParameterMakeObject(
          "address",
          formDataAccountant,
          data.address,
        );
        helpers.isParameterMakeObject("name", formDataAccountant, data.name);
        helpers.isParameterMakeObject(
          "countryCode",
          formDataAccountant,
          countryCodes.countryCode,
        );
        helpers.isParameterMakeObject(
          "mobile",
          formDataAccountant,
          data.mobile,
        );
        helpers.isParameterMakeObject("city", formDataAccountant, data.city);
        helpers.ifParameter(cat, formDataAccountant, "countryID", cat);
        helpers.ifParameter(state, formDataAccountant, "stateID", state);
        await helpers.cropPicture(
          picture,
          "profilePicture",
          formDataAccountant,
        );
      }
      reset();
      updateProfile(formData, formDataHR, formDataAccountant, setPicture);
    } catch (err) {
      console.log("err:", err);
    } finally {
      setUpdateProfileLoading(false);
    }
  };

  const getCountryList = async () => {
    try {
      const res = await apiGet(apiPath.getCountryCityList, {});
      setRecordTemp(res?.data?.results?.country);
      setListTemp(res?.data?.results?.city);
    } catch (error) {
      console.log("error:", error);
    }
  };

  useEffect(() => {
    getCountryList();
  }, []);

  const getStateList = async (countryId) => {
    try {
      const res = await apiGet(
        `${apiPath.getStateListByCountry}/${countryId}`,
        {},
      );
      if (res?.data?.success && Array.isArray(res.data.results.allStates)) {
        setStateList(res.data.results.allStates);
        return res.data.results;
      }
      return [];
    } catch (error) {
      console.error("Error loading states:", error);
      return [];
    }
  };

  useEffect(() => {
    getStateList(selectedCountry);
  }, [selectedCountry]);

  useEffect(() => {
    updatePageName(t("EDIT_PROFILE"));
  }, []);
  const codeValue = helpers?.ternaryCondition(
    watch("email"),
    watch("email"),
    "",
  );

  return (
    <div className="bg-[#F9F9F9]">
      <div className="py-2">
        <div className="bg-white border border-[#E9EDF9] rounded-lg py-4 ">
          <form
            onSubmit={handleSubmit(handleSubmitForm, () => {
              const isValid = checkFields();
              if (!isValid) return;
            })}
            method="post"
          >
            <div className="grid lg:grid-cols-3 sm:grid-cols-2">
              <div className="py-4 px-4 md:px-8">
                <div className="relative">
                  <OInputField
                    greyClass
                    wrapperClassName="relative z-0 mb-6 w-full group"
                    name="name"
                    inputLabel={
                      <>
                        {t("NAME")}
                        <span className="text-red-500">*</span>
                      </>
                    }
                    type="text"
                    autoFocus
                    onInput={(e) => preventMaxInput(e)}
                    register={register("name", formValidation["adminName"])}
                    errors={errors}
                  />
                </div>
              </div>
              <div className="py-4 px-4 md:px-8">
                <div className="relative">
                  <OInputField
                    greyClass
                    wrapperClassName="relative z-0  mb-6 w-full group"
                    type="text"
                    name="email"
                    id="email"
                    value={codeValue.toLowerCase()}
                    inputLabel={
                      <>
                        {t("O_EMAIL_ID")}
                        <span className="text-red-500">*</span>
                      </>
                    }
                    maxLength={50}
                    onInput={(e) => preventMaxInput(e, 50)}
                    register={register("email", formValidation["email"])}
                    errors={errors}
                    disabled={
                      user?.role === "HRAdmin" ||
                      user?.role === "AccountantAdmin"
                    }
                  />
                </div>
              </div>
              {user?.role === "HRAdmin" || user?.role === "AccountantAdmin" ? (
                <>
                  <div className="md:py-4 sm:px-2 sm:py-8 px-7 flex">
                    {recordsTemp?.length > 0 &&
                      recordsTemp?.map((item) => {
                        if (selectedCountry === item?._id) {
                          return (
                            <div key={item?._id} className="w-[50px] h-[56px] mr-3 block py-4 px-3  text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer">
                              {item?.countryCode}
                            </div>
                          );
                        }
                      })}

                    <div className="relative z-0 w-full group">
                      <OInputField
                        wrapperClassName="relative z-0 mb-6 w-full group"
                        type="number"
                        name="mobile"
                        id="mobile"
                        inputLabel={
                          <>
                            {t("O_MOBILE")}
                            <span className="text-red-500">*</span>
                          </>
                        }
                        min={0}
                        onKeyDown={(e) => {
                          if (["-", "+", "e"].includes(e.key)) {
                            e.preventDefault();
                          }
                        }}
                        onInput={(e) => preventMaxInput(e, 15)}
                        register={register("mobile", formValidation["mobile"])}
                        errors={errors}
                      />
                    </div>
                  </div>
                  <div className="py-4 px-4 md:px-8">
                    <div className="relative">
                      <select
                        type="select"
                        name="country"
                        id="country"
                        className="block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer"
                        placeholder=" "
                        value={cat}
                        onChange={(e) => {
                          setCat(e.target.value);
                          setSelectedCountry(e.target.value);
                          setSubCat("");
                          if (e.target.value) {
                            setIsCatError(false);
                          }
                        }}
                      >
                        <option value={""}>{t("SELECT_COUNTRY")}</option>
                        {recordsTemp?.length &&
                          recordsTemp?.map((i, key) => (
                            <option key={key} value={i._id}>
                              {i.name}
                            </option>
                          ))}
                      </select>
                      <label
                        htmlFor="country"
                        className="peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                      >
                        {t("COUNTRY")}
                        <span className="text-red-500">*</span>
                      </label>
                      {isCatError && (
                        <ErrorMessage message="Please select country." />
                      )}
                    </div>
                  </div>
                  <div className="py-4 px-4 md:px-8">
                    <div className="relative">
                      <select
                        type="select"
                        name="state"
                        id="state"
                        className="block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer"
                        placeholder=" "
                        value={state}
                        onChange={(e) => {
                          setState(e.target.value);
                          if (e.target.value === "") {
                            setIsStateError(true);
                          } else {
                            setIsStateError(false);
                          }
                        }}
                      >
                        <option value="">{t("SELECT_CITY")}</option>
                        {stateList?.length &&
                          stateList?.map(
                            (i, key) =>
                              i?.countryID == cat && (
                                <option key={key} value={i?._id}>
                                  {i?.name}
                                </option>
                              ),
                          )}
                      </select>
                      <label
                        htmlFor="state"
                        className="peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                      >
                        {t("STATE")}
                        <span className="text-red-500">*</span>
                      </label>
                      {isStateError && (
                        <ErrorMessage message="Please select state." />
                      )}
                    </div>
                  </div>
                  <div className="py-4 px-4 md:px-8">
                    <div className="relative">
                      <OInputField
                        wrapperClassName="relative z-0 mb-6 w-full group"
                        name="city"
                        maxLength={300}
                        onInput={(e) => preventMaxInput(e, 300)}
                        inputLabel={
                          <>
                            {t("CITY")}
                            <span className="text-red-500">*</span>
                          </>
                        }
                        type="text"
                        register={register("city")}
                        errors={errors}
                      />
                    </div>
                  </div>
                  <div className="py-4 px-4 md:px-8">
                    <div className="relative">
                      <OInputField
                        wrapperClassName="relative z-0 mb-6 w-full group"
                        name="address"
                        maxLength={300}
                        onInput={(e) => preventMaxInput(e, 300)}
                        inputLabel={
                          <>
                            {t("ADDRESS")}
                            <span className="text-red-500">*</span>
                          </>
                        }
                        type="text"
                        register={register(
                          "address",
                          formValidation["address"],
                        )}
                        errors={errors}
                      />
                    </div>
                  </div>
                </>
              ) : (
                ""
              )}
              <div>
                <div className="py-4 px-4 md:px-8">
                  <div className="relative w-24 h-24 ">
                    <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white w-28">
                      {t("PROFILE_PICTURE")}
                    </label>
                    <input
                      type="file"
                      accept="image/png, image/jpg, image/jpeg"
                      name="image"
                      ref={profilePicRef}
                      onChange={handleFileChange}
                      className="hidden"
                    />
                    <OImage
                      src={
                        picture.croppedImg
                          ? picture.croppedImg
                          : user?.profilePic || user?.profilePicture
                      }
                      fallbackUrl="/images/user.png"
                      className="w-24 h-24"
                      alt=""
                      style={{ borderRadius: "50%" }}
                    />
                    <AiFillCamera
                      className=" bg-gray-100  absolute w-4 rounded-xl cursor-pointer"
                      style={{
                        width: "1.5rem",
                        height: "1.5rem",
                        bottom: "-23px",
                        right: 0,
                        background: "",
                        padding: "1px",
                      }}
                      onClick={() => profilePicRef?.current?.click()}
                    />
                  </div>
                </div>
                <div className="text-center mt-4">
                  <ErrorMessage message={profilePicError} />
                </div>
              </div>
            </div>
            <div className="flex justify-center mt-4">
              <OButton
                disabled={!isDirty && picture.croppedImg == null}
                label="Submit"
                type="submit"
                loading={updateProfileLoading}
              />
            </div>
          </form>
        </div>
      </div>
      <>
        <Dialog
          open={open}
          onClose={() => setOpen(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {picture.cropperOpen && (
                <div className="pb-0 bg-white shadow-lg mt-[30px]">
                  <AvatarEditor
                    ref={setEditorRef}
                    image={picture.img}
                    width={200}
                    height={200}
                    border={50}
                    color={[255, 255, 255, 0.6]}
                    rotate={0}
                    scale={picture.zoom}
                    sc
                    className="m-auto mb-4"
                  />
                  <Slider
                    aria-label="raceSlider"
                    value={picture.zoom}
                    min={1}
                    max={10}
                    step={0.1}
                    onChange={handleSlider}
                  ></Slider>
                  <div className="flex items-center justify-center p-6 border-t border-solid border-slate-200 rounded-b">
                    <button
                      className="text-black bg-[#E1E1E1] font-normal   px-12 py-2.5 text-sm outline-none focus:outline-none rounded mr-6  ease-linear transition-all duration-150"
                      type="button"
                      onClick={handleCancel}
                    >
                      Cancel
                    </button>
                    <button
                      className={` bg-LightBlue cursor-pointer  text-white active:bg-emerald-600 font-normal text-sm px-8 py-2.5 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1  ease-linear transition-all duration-150`}
                      type="submit"
                      onClick={handleSave}
                    >
                      Save
                    </button>
                  </div>
                </div>
              )}
            </DialogContentText>
          </DialogContent>
        </Dialog>
      </>
    </div>
  );
};

export default Profile;
